import * as React from 'react';
import { withMemo } from 'PyzShopUi/scripts/react/common/hoc/withMemo';

interface IMarkerProps {
    label: string;
    color: 'blue' | 'red';
}

const Marker: React.FunctionComponent<IMarkerProps> = props => {
    const { label, color } = props;

    const colorClassName = color ? ('marker--' + color) : '';

    return (
        <div className={`marker ${colorClassName}`}>
            <span>{label}</span>
        </div>
    );
};

export default withMemo(Marker);
